import { useEffect, useState } from 'react'
import { Box, Collapse, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import PsychologyIcon from '@mui/icons-material/Psychology'

export const ReasoningPanel = ({
  reasoning,
  hasFinalText,
}: {
  reasoning: string
  hasFinalText: boolean
}) => {
  const [open, setOpen] = useState(true)

  // Klappt automatisch zu, sobald die finale Antwort zu streamen beginnt.
  useEffect(() => {
    if (hasFinalText) setOpen(false)
  }, [hasFinalText])

  if (!reasoning) return null

  return (
    <Box sx={{ mb: 1 }}>
      <Box
        onClick={() => setOpen((prev) => !prev)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          cursor: 'pointer',
          color: 'text.secondary',
          userSelect: 'none',
        }}
      >
        <PsychologyIcon fontSize="small" />
        <Typography variant="caption">
          {hasFinalText ? 'Denkprozess' : 'Denkt nach …'}
        </Typography>
        {open ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
      </Box>
      <Collapse in={open}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ whiteSpace: 'pre-wrap', pl: 2, borderLeft: '2px solid', borderColor: 'divider' }}
        >
          {reasoning}
        </Typography>
      </Collapse>
    </Box>
  )
}
